if (!customElements.get('header-drawer')) {
  customElements.define('header-drawer', class HeaderDrawer extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');

      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }

    bindEvents() {
      this.querySelectorAll('summary').forEach(summary => {
        summary.addEventListener('click', this.onSummaryClick.bind(this));
      });

      this.querySelectorAll('button').forEach(button => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      const openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) return;

      openDetailsElement.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').focus();
    }

    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const openDetailsElement = this.mainDetailsToggle.querySelector('details[open]');

      if (openDetailsElement && openDetailsElement !== detailsElement) {
        openDetailsElement.removeAttribute('open');
      }

      if (detailsElement.hasAttribute('open')) {
        const focusableElement = detailsElement.querySelector('button, a');
        focusableElement && focusableElement.focus();
      }
    }

    onButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      detailsElement.removeAttribute('open');
    }

    onFocusOut(event) {
      setTimeout(() => {
        if (this.contains(document.activeElement)) return;
        const openDetailsElement = this.querySelector('details[open]');
        openDetailsElement && openDetailsElement.removeAttribute('open');
      });
    }
  });
}

